const dbs = {}

const dbVersion = 7

const openDatabase = (dbName) => (
  new Promise((resolve, reject) => {
    if (!!dbs[dbName]) return resolve(dbs[dbName])

    const request =
      window.indexedDB.open(dbName, dbVersion)

    request.onerror = reject

    request.onupgradeneeded = (event) => {
      const db = event.target.result

      if (!db.objectStoreNames.contains("foods")) {
        db.createObjectStore("foods", { keyPath: "_id" })
      }

      if (!db.objectStoreNames.contains("combos")) {
        db.createObjectStore("combos", { keyPath: "_id" })
      }

      if (!db.objectStoreNames.contains("categories")) {
        db.createObjectStore("categories", { keyPath: "_id" })
      }

      if (!db.objectStoreNames.contains("foodSpecifications")) {
        db.createObjectStore("foodSpecifications", { keyPath: "_id" })
      }

      if (!db.objectStoreNames.contains("foodTaxes")) {
        db.createObjectStore("foodTaxes", { keyPath: "_id" })
      }

      if (!db.objectStoreNames.contains("offlineOrders")) {
        db.createObjectStore("offlineOrders", { keyPath: "offlineOrderId" })
      }
    }

    request.onsuccess = () => {
      dbs[dbName] = request.result

      resolve(request.result)
    }
  })
)

const closeDatabase = (dbName) => {
  dbs[dbName].close()
}

const deleteItemsFromDatabase = async (dbName, storeName, foodIds) => (
  new Promise(async (resolve, reject) => {
    const db = await openDatabase(dbName, storeName)

    const transaction =
      db.transaction(storeName, "readwrite")

    const objectStore =
      transaction.objectStore(storeName)

    foodIds.forEach((foodId) => {
      objectStore.delete(foodId)
    })

    transaction.oncomplete = resolve

    transaction.onerror = reject
  })
)

const deleteDatabase = (dbName) => (
  new Promise(async (resolve, reject) => {
    const req = indexedDB.deleteDatabase(dbName)

    req.onsuccess = resolve

    req.onerror = reject
  })
)

const saveItemsToDatabase = async (dbName, storeName, items) => (
  new Promise(async (resolve, reject) => {
    const db = await openDatabase(dbName, storeName)

    const transaction =
      db.transaction(storeName, "readwrite")

    const objectStore =
      transaction.objectStore(storeName)

    items.forEach((item) => {
      objectStore.put(item)
    })

    transaction.oncomplete = resolve

    transaction.onerror = reject
  })
)

const getAllItemsFromDatabase = (dbName, storeName) => (
  new Promise(async (resolve, reject) => {
    const db = await openDatabase(dbName, storeName)

    const transaction = db.transaction(storeName, "readonly")

    const objectStore = transaction.objectStore(storeName)

    const query = objectStore.getAll()

    query.onsuccess = () => {
      resolve(query.result)
    }

    transaction.onerror = reject
  })
)

const idb = {
  deleteDatabase,
  closeDatabase,
  saveItemsToDatabase,
  getAllItemsFromDatabase,
  deleteItemsFromDatabase
}

export default idb